module.exports = function(length) {
  function runway(t) {
    return [[-length * t, 0], t + 1 / length];
  }

  return runway;
};



/*****************
 ** WEBPACK FOOTER
 ** ../JSCalligrapher/alphabets/abjad/runway.js
 ** module id = 15
 ** module chunks = 0
 **/